/**
 * ================================
 * Useful utility types that doesn't have anything to do with tRPC in particular
 * ================================
 */ /**
 * @public
 */ const ERROR_SYMBOL = Symbol('TypeError');

export { ERROR_SYMBOL };
